import { OdaxObjectiveEnum, OptimizationGoalEnum } from "../enums";

export const optimizationGoalByObjective: any = {
    [OdaxObjectiveEnum.OUTCOME_TRAFFIC]: OptimizationGoalEnum.LANDING_PAGE_VIEWS,
    [OdaxObjectiveEnum.OUTCOME_AWARENESS]: OptimizationGoalEnum.REACH,
    [OdaxObjectiveEnum.OUTCOME_SALES]: OptimizationGoalEnum.OFFSITE_CONVERSIONS
}